import { useMutation, useQueryClient } from "react-query";
import { UpdateWorkspaceGroupData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";
import { workspaceQueryKeys } from "./queryKeys";

export const useUpdateWorkspaceGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: UpdateWorkspaceGroupData) => workspaceService.updateGroup(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allGroups);
      },
    }
  );
};
